<template lang="pug">
    #app.app
        transition(name="fade")
            rsl-notification(
                v-bind="getNotificationInfo"
                v-if="getNotificationInfo.isVisible"
                v-on:close="closeNotification"
            )
        template(v-if='!isAppLoading')
            the-header
            router-view
        .app__loader(v-else)
            rsl-loader(
            viewType="book"
            iconClass="preloader-icon__book")
        transition(name="fade")
            modal(v-if="isModalVisible")

</template>

<script>
import { mapGetters } from 'vuex';
import RslNotification from '@RSL/RslNotification/RslNotification';
import RslLoader from '@RSL/RslLoader/RslLoader';
import Modal from '@/components/modal/Modal';
import TheHeader from '@/components/partials/TheHeader';

export default {
    name: 'App',
    components: {
        TheHeader,
        Modal,
        RslNotification,
        RslLoader
    },
    computed: {
        ...mapGetters([
            'getNotificationInfo',
            'isAppLoading',
            'isModalVisible'
        ])
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        this.handleResize();
    },
    created() {
        window.addEventListener('resize', this.handleResize);
    },
    methods: {
        closeNotification() {
            this.$store.commit('SET_NOTIFICATION_INFO', {
                isVisible: false
            });
        },
        handleResize() {
            this.$store.commit('SET_WINDOW_WIDTH', window.innerWidth);
        }
    }
};
</script>
